import Vue from 'vue'
const EventBus = new Vue();

const OPEN_DISCLOSURE_MODAL_EVENT = 'open-disclosure-modal';

export const emitOpenDisclosureModal = () => {
    EventBus.$emit(OPEN_DISCLOSURE_MODAL_EVENT);
};

export const onOpenDisclosureModal = (callback) => {
    EventBus.$on(OPEN_DISCLOSURE_MODAL_EVENT, callback);
};

export const offOpenDisclosureModal = (callback) => {
    EventBus.$off(OPEN_DISCLOSURE_MODAL_EVENT, callback);
};
